export class FacebookTracker
{
    track(type, params)
    {
        if(isDevelopment) {
            //console.log('track', type, params);
        } else if (typeof params === 'object') {
            window.fbq('track', type, params);
        } else {
            window.fbq('track', type);
        }
    }

    viewContent(params)
    {
        this.track('ViewContent', params);
    }

    viewContentProduct(product)
    {
        this.viewContent({
            value: product.price,
            currency: product.currency,
            content_ids: product.product_uid,
            content_type: 'product'
        });
    }

    viewContentCategory(category)
    {
        this.viewContent({
            content_ids: category.id,
            content_type: 'product_group'
        });
    }

    search()
    {
        this.track('Search');
    }

    addToCart(product)
    {
        this.track('AddToCart', {
            value: product.price,
            currency: product.currency,
            content_ids: product.uid,
            content_type: 'product'
        });
    }

    addToWishlist()
    {
        this.track('AddToWishlist');
    }

    addReview()
    {
        this.track('AddReview');
    }

    addQuestion()
    {
        this.track('AddQuestion');
    }

    productNotificationAdd()
    {
        this.track('ProductNotificationAdd');
    }

    initiateCheckout()
    {
        this.track('InitiateCheckout');
    }

    addPaymentInfo()
    {
        this.track('AddPaymentInfo');
    }

    purchase(orderInfo)
    {
        this.track('Purchase', {
            'value' : orderInfo.price,
            'currency': orderInfo.currency
        });
    }

    lead(params)
    {
        this.track('Lead', params);
    }

    leadOrder(orderInfo)
    {
        this.lead({
            'value' : orderInfo.price,
            'currency': orderInfo.currency
        });
    }

    completeRegistration()
    {
        this.track('CompleteRegistration');
    }

    newsletterSubscription()
    {
        this.track('NewsletterSubscription');
    }

    selectedShop()
    {
        this.track('SelectedShop');
    }

    requestCallBack()
    {
        this.track('RequestCallBack');
    }

    applyingFilter()
    {
        this.track('ApplyingFilter');
    }

    buyOneClick()
    {
        this.track('BuyOneClick');
    }

    clickSocialNetwork()
    {
        this.track('SocialNetwork');
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/facebook.js